import { accountingConfigByLocale } from './index'; // Return currency format depending on the provided locale

export var getCurrencyFormatByLocale = function getCurrencyFormatByLocale(value, locale) {
  if (locale === void 0) {
    locale = 'en_US';
  }

  var _accountingConfigByLo = accountingConfigByLocale[locale].format,
      pos = _accountingConfigByLo.pos,
      neg = _accountingConfigByLo.neg,
      zero = _accountingConfigByLo.zero;

  if (value > 0) {
    return pos;
  }

  if (value < 0) {
    return neg;
  }

  return zero;
};
//# sourceMappingURL=currencyUtils.js.map